  angular.module("core")
  
  .directive("ngUserInput", function () {
    return {

      restrict: "A",
      scope: {
        onEnterCallback: "=ngUserInput",
        inputIsEmpty: "=",
        busy: "="        
      },
      template: "<textarea class=\"text\" cols=\"40\" rows=\"3\" placeholder=\"{{ busy ? 'Please wait...' : 'Type your message here and press enter to send' }}\" ng-model=\"userInput\" ng-change=\"checkInput(userInput)\"></textarea>",
      replace: true,
      link: function (scope, element) {

        scope.userInput = "";

        scope.checkInput = function(){
          scope.inputIsEmpty = !scope.userInput || !scope.userInput.length;
        }

        // detect enter key press to submit
        $(element).keypress(function (e) {
          var code = (e.keyCode ? e.keyCode : e.which);
          // check if key is enter
          if (code === 13 && !e.shiftKey) {
            e.preventDefault();

            if(!scope.userInput.length){
              return false;
            }
            scope.$apply(function () {
              scope.onEnterCallback(scope.userInput);
              scope.userInput = "";
              scope.inputIsEmpty = true;
            });
            return false;
          }
        });

      }
    };
  });
